import { MomentService } from 'src/app/shared/services/moment.service';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { Component, OnInit, Input } from '@angular/core';
import { User } from 'src/app/shared/models/users';

@Component({
  selector: 'app-dispersion-user',
  templateUrl: './dispersion-user.component.html',
  styleUrls: ['./dispersion-user.component.scss']
})
export class DispersionUserComponent implements OnInit {
  public dispersions: any[];
  private _card: any;
  @Input('card') set card(data) {
    this._card = data;
  }
  @Input('user') user: User;
  
  public filters: {
    dateStart: Date,
    dateEnd: Date
  }

  constructor(
    private dispersions_service: DispersionsService,
    private moment_service: MomentService
  ) {
    this.filters = {
      dateStart: new Date(),
      dateEnd: new Date()
    }
  }

  get card() { return this._card }

  ngOnInit() {
    this.getDispersions();
  }

  getDispersions(e?) {
    console.log('********************* Obtener Dispersiones del Usuario *********************');
    this.dispersions_service.getDispersionsByUser(this.user.id, this.filters.dateStart, this.filters.dateEnd).toPromise()
    .then((result: any) => {
      console.log(result);
      this.dispersions = result.dispersions;
    })
    .catch(error => {
      console.log(error);
    })
  }

  onRowPrepared(e) {
    if (e.rowType == "data" && (`${e.data?.urls || ''}`.trim() == "")) {
      e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
    }  
  }

  getDate(date,inFormat, outFormat) {
    return date ? this.moment_service.moment(date,inFormat).format(outFormat) : null;
  }
}
